export default "__VITE_ASSET__Bfpas5It__"